const en = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    cancelDelete: 'Cancel deletion',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    back: 'Back',
    search: 'Search',
    remove: 'Remove',
    close: 'Close',
    closeMenu: 'Close menu',
    loading: 'Loading...',
    somethingWentWrong: 'Something went wrong',
    yes: 'Yes',
    no: 'No',
    required: 'Required',
    noResults: 'No results',
    home: 'Home',
    link: 'Link',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
  },
  serviceUnavailable: {
    title: 'Service unavailable',
    message: 'We are unable to reach the service right now.<br/>Please try again in a few moments.',
    retry: 'Try again',
    retryCooldown: 'Try again ({{seconds}})',
  },
  header: {
    welcome: 'Welcome,',
    logout: 'Log out',
    language: 'Language',
    languageGreek: 'Ελληνικά',
    languageEnglish: 'English',
  },
  branchSelector: {
    selectBranchTitle: 'Select branch',
    selectBranchLabel: 'Select branch:',
    save: 'Save',
  },
  menu: {
    overview: 'Overview',
    contacts: 'Contacts',
    leads: 'Leads',
    companies: 'Companies',
    orders: 'Orders',
    employees: 'Employees',
    bookings: 'Calendar',
    services: 'Services',
    settings: 'Settings',
    statistics: 'Statistics',
    ergani: 'ERGANI',
    workCard: 'Work Card',
  },
  admin: {
    title: 'Administration',
    tenants: {
      title: 'Tenants',
      addButton: 'Add tenant',
      list: {
        subtitle: 'Manage organizations, plans, and tenant access.',
        searchPlaceholder: 'Search by name or organization ID',
        remindersChip: 'Reminders',
        totalTenants: 'Total tenants',
        featuresCount_one: '{{count}} feature',
        featuresCount_other: '{{count}} features',
      },
      empty: 'No tenants found',
      featurePlaceholder: 'Choose features',
      smsDisabled: 'SMS disabled',
      senderWarning:
        'Copy the exact sender ID from the provider console. <b>This value can never be changed afterwards.</b> Nothing in Bookingplus can validate it: a value that is not registered is not rejected — the provider substitutes its own sender or drops the message.',
      quotaUsage: '{{used}} / {{limit}} used since {{date}}',
      sections: { identity: 'Identity', plan: 'Plan', limits: 'Limits', smsQuota: 'SMS quota' },
      fields: {
        name: 'Name',
        alias: 'Alias',
        organizationId: 'Organization ID',
        tier: 'Tier',
        features: 'Features',
        branchLimit: 'Branch limit',
        smsLimit: 'SMS limit',
        senderName: 'Sender name',
      },
      buttons: { save: 'Save', renewQuota: 'Renew quota', changeSender: 'Change sender' },
      dialogs: { renewTitle: 'Renew SMS quota', changeSenderTitle: 'Change sender name' },
      validation: { mobileInvalid: 'Mobile phone is not valid' },
      snackbars: {
        created: 'Tenant created successfully!',
        createFailed: 'Failed to create tenant',
        updated: 'Tenant updated successfully!',
        updateFailed: 'Failed to update tenant',
        loadFailed: 'Failed to load tenant',
        quotaRenewed: 'SMS quota renewed successfully',
      },
      detail: {
        planLimitsTitle: 'Plan & limits',
        tierLabel: 'Tier *',
        featuresLabel: 'Features',
        aliasLabel: 'Alias',
        organizationIdLabel: 'Organization ID',
        reminders: {
          title: 'Booking reminders',
          on: 'On',
          off: 'Off',
          subtitleConfigured: 'SMS reminders sent to customers before their appointment.',
          setupInProgress: 'Setup in progress',
          setupButton: 'Set up',
          cancelSetup: 'Cancel setup',
          subtitleSetup: 'Three steps left before this can be saved',
          subtitleOffNotConfigured: 'Off · SMS not configured for this tenant',
          subtitleOffDisabled: 'Off · SMS reminders disabled',
          infoBanner:
            'Reminders stay off until you finish setup and press Save. The feature cannot be switched on without submitting the SMS config below.',
        },
        steps: {
          mobileNumberLabel: 'Mobile number *',
          step1: {
            title: 'Register the sender name at the SMS provider',
            description:
              'Happens outside Bookingplus and cannot be automated or checked from here. Register the sender ID for this tenant first, then record it below.',
            link: 'Open provider console',
            done: 'Registered at the provider',
          },
          step2: {
            title: 'Record the sender name',
            placeholder: 'e.g. BKPLUS',
            helper: 'Up to 11 alphanumeric characters, as registered at the provider',
            setButton: 'Set',
            doneRecorded: 'Sender name <code>{{name}}</code> recorded',
            doneCaption: 'Not written to the tenant until Save — Cancel still discards it',
          },
          step3: {
            title: 'Verify with a test SMS',
            descriptionReady:
              'Sends one real message as <code>{{sender}}</code> to a number you can read. It does not count against quota, but it is billable at the provider.',
            descriptionMuted: 'Available after the sender name is recorded.',
            mobileHelper: 'Use a phone you can check right now',
            sendButton: 'Send test SMS',
            verified: '✓ SMS received and sender verified',
          },
          step4: {
            title: 'Set the SMS quota',
            descriptionReady: 'Opens a new usage window from now.',
            descriptionMuted: 'Available once you confirm the test SMS arrived.',
            limitLabel: 'SMS limit per window *',
            limitError: 'Must be greater than 0 — a limit of 0 leaves the tenant unable to send',
            setButton: 'Set quota',
            done: 'SMS limit set to <code>{{limit}}</code> per window',
          },
        },
        renewDialog: { limitLabel: 'SMS limit per window', confirm: 'Confirm' },
        testDialog: {
          titleBefore: 'Send a test SMS',
          titleAfter: 'Test SMS handed to the provider',
          intro: 'One real message, sent as <code>{{sender}}</code> to a number you can check.',
          mobileHelper: 'Use a phone you can read right now — you have to compare the sender it arrives from.',
          infoNote:
            'The message names the configured sender in its body. If the sender shown on your phone differs, the sender ID is not registered with the provider.',
          senderUsed: 'Sender used',
          smsId: 'SMS ID',
          recipient: 'Recipient',
          deliveryState: 'Delivery state',
          stateDelivered: 'delivered',
          stateFailed: 'delivery failed',
          statePending: 'no provider callback yet',
          pendingExplainer:
            'PENDING means no delivery callback has landed — it does not mean the message failed. Your phone is the source of truth.',
          confirmReceived: 'I received the SMS and it arrived from <code>{{sender}}</code>',
          confirmCaption: 'Unlocks the quota step. Remembered for this visit only — reloading the page asks again.',
          sendAnother: 'Send another',
          continueToQuota: 'Continue to quota',
          sendReal: 'Send real SMS',
          sending: 'Sending…',
        },
        saveBlockedHint: 'Finish the SMS setup to save',
        leaveDialog: {
          title: 'Discard unsaved changes?',
          body: 'Changes on this page, including reminder setup progress, will be lost.',
          stay: 'Stay',
          discard: 'Discard',
        },
        offDialog: {
          title: 'Stop sending booking reminders?',
          body: 'Customers of <b>{{name}}</b> stop receiving SMS reminders as soon as this is saved.',
          caption: 'Sender name, quota and usage are kept — switching reminders back on later needs no setup.',
          keepSending: 'Keep sending',
          turnOff: 'Turn off reminders',
        },
        configured: {
          title: 'SMS configuration',
          senderHelper:
            'Up to 11 alphanumeric characters. Permanent once saved — it has to stay in parity with the sender ID registered at the provider. Send a test SMS any time to re-check delivery.',
          smsLimitLabel: 'SMS limit per window *',
          limitHelper: 'Only changed through Renew quota below, which also opens a new usage window from now.',
          usageTitle: 'SMS usage in this window',
          since: 'Since {{date}} · earlier windows not counted',
          ofUsed: 'of {{limit}} used',
          remaining: '{{count}} remaining',
          threshold: '80% warning threshold',
          warning: 'Past the 80% threshold. Renew it before the quota runs out or reminders stop.',
          delivered: 'Delivered',
          pending: 'Pending',
          failed: 'Failed',
          windowOpened: 'Window opened',
          footnote:
            'Delivered + pending + failed = {{usage}}, the figure counted against the quota. Failed and pending sends consumed quota too — the provider was called either way.',
        },
        snackbars: { testSmsSent: 'Test SMS handed to the provider', testSmsFailed: 'Failed to send test SMS' },
      },
    },
  },
  breadcrumbs: {
    contacts: 'Contacts',
    services: 'Services',
    employees: 'Employees',
    orders: 'Orders',
    settings: 'Settings',
    employeePlan: 'Calendar',
    workCard: 'Work Card',
    ergani: 'Ergani employees',
    attendance: 'Check-in/check-out details',
  },
  enums: {
    companyType: {
      IKE: 'Private capital company',
      EPE: 'Limited liability company',
      AE: 'Public limited company',
      OE: 'General partnership',
      EE: 'Limited partnership',
      SOLE_PROPRIETORSHIP: 'Sole proprietorship',
    },
    companyRole: {
      OWNER: 'Owner',
    },
    bookingStatus: {
      ACTIVE: 'Active',
      COMPLETED: 'Completed',
      CANCELLED: 'Cancelled',
      NO_SHOW: 'No show',
      PENDING: 'Unconfirmed',
    },
    communicationStatus: {
      DRAFT: 'Draft',
      IN_PROGRESS: 'In progress',
      RECALL: 'Recall',
      REJECTED: 'Rejected',
      COMPLETED: 'Completed',
    },
    orderStatus: {
      DRAFT: 'Draft',
      SUBMITTED: 'Submitted',
      UNDER_NEGOTIATION: 'Under Negotiation',
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected',
      CANCELLED: 'Cancelled',
      EXPIRED: 'Expired',
      PENDING: 'Pending',
      PROCESSING: 'Processing',
      COMPLETED: 'Completed',
      ON_HOLD: 'On Hold',
      FAILED: 'Failed',
      SHIPPED: 'Shipped',
    },
    gender: {
      FEMALE: 'Female',
      MALE: 'Male',
      OTHER: 'Other',
      UNKNOWN: 'Unknown',
    },
    dayOfWeek: {
      MONDAY: 'Monday',
      TUESDAY: 'Tuesday',
      WEDNESDAY: 'Wednesday',
      THURSDAY: 'Thursday',
      FRIDAY: 'Friday',
      SATURDAY: 'Saturday',
      SUNDAY: 'Sunday',
    },
    paymentMethod: {
      BANK_TRANSFER: 'Bank transfer',
      CASH: 'Cash',
      CARD: 'Card',
      ON_CREDIT: 'On credit',
    },
    invoicePaymentMethod: {
      DEBIT_CARD: 'Debit card',
      CREDIT_CARD: 'Credit card',
      CASH: 'Cash',
    },
    invoiceStatus: {
      DRAFT: 'Draft',
      PENDING: 'Awaiting confirmation',
      ISSUED: 'Issued',
      FAILED: 'Rejected by AADE',
      CANCELLED: 'Cancelled',
      REVERSED: 'Credited',
      DISCARDED: 'Discarded',
    },
    invoiceDocumentType: {
      SERVICE_RECEIPT: 'Service receipt',
      RETAIL_CREDIT_NOTE: 'Retail credit note',
      SERVICE_INVOICE: 'Service invoice',
      SERVICE_CREDIT_INVOICE: 'Credit invoice',
    },
    country: {
      AT: 'Austria',
      BE: 'Belgium',
      BG: 'Bulgaria',
      HR: 'Croatia',
      CY: 'Cyprus',
      CZ: 'Czechia',
      DK: 'Denmark',
      EE: 'Estonia',
      FI: 'Finland',
      FR: 'France',
      DE: 'Germany',
      GR: 'Greece',
      HU: 'Hungary',
      IE: 'Ireland',
      IT: 'Italy',
      LV: 'Latvia',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MT: 'Malta',
      NL: 'Netherlands',
      PL: 'Poland',
      PT: 'Portugal',
      RO: 'Romania',
      SK: 'Slovakia',
      SI: 'Slovenia',
      ES: 'Spain',
      SE: 'Sweden',
      GB: 'United Kingdom',
    },
    providerStatus: {
      PENDING_ACTIVATION: 'Pending activation',
      ACTIVE: 'Active',
      PENDING_MANUAL_LINK: 'Pending link by support',
      FAILED: 'Failed',
    },
    providerActivationRequirement: {
      LEGAL_NAME: 'The company needs a legal name.',
      REGISTERED_ADDRESS: 'The company needs a registered address.',
      UNIQUE_CONTACT_EMAIL: 'A contact email is needed that no other company already uses.',
      CONTACT_PHONE: 'A contact phone number is needed.',
    },
  },
  searchDialogs: {
    company: {
      titleNew: 'Link company',
      titleEdit: 'Update contact-company link',
      companyLabel: 'Company',
      roleLabel: 'Role',
      saveButton: 'Save',
      linkButton: 'Link',
    },
    contact: {
      titleNew: 'Link contact',
      titleEdit: 'Update contact-company link',
      contactLabel: 'Contact',
      roleLabel: 'Role',
      saveButton: 'Save',
      linkButton: 'Link',
    },
  },
  contacts: {
    listTitle: 'Contacts',
    addContact: 'Create contact',
    backToList: 'Contacts list',
    createTitle: 'Create contact',
    select: 'Select',
    columns: {
      lastName: 'Last name',
      firstName: 'First name',
      mobilePhone: 'Mobile phone',
      additionalPhone: 'Landline phone',
      email: 'Email',
      source: 'Source',
      branch: 'Branch',
    },
    tooltips: {
      lead: 'Lead (has an offer/order)',
      customer: 'Customer (has a completed order)',
      mobileCheck: 'Check phone number usage in existing contacts',
    },
    search: {
      mobilePlaceholder: 'First name, Last name, Mobile, Email',
    },
    sections: {
      basicInfo: 'Basic information',
      contactInfo: 'Contact details',
      additionalInfo: 'Additional information',
      linkedCompanies: 'Linked companies',
      bookingReminders: 'Upcoming booking reminders',
    },
    reminders: {
      lede: 'What this client has agreed to receive before their upcoming bookings. This record applies to all of their bookings, not to any single one.',
      confirmationsNotice:
        'Booking confirmations and cancellations are always sent, whatever this record says. This governs the reminders before an upcoming booking — nothing else.',
      permanence:
        'Every change to this record is written permanently, against your name and the time you made it, and cannot be corrected or removed afterwards — including anything you gave as a reason.',
      // Shown only when the record itself is ready and something the section cannot display
      // is what blocks the save. A missing reason is never this: it says so in its own box.
      blockedElsewhere: 'This cannot be saved yet: another field on this contact needs fixing. Check the fields marked above.',
      statement: {
        prefix: 'This client',
        on: 'receives {{channel}} reminders',
        off: 'asked to stop {{channel}} reminders',
      },
      // Says WHEN and nothing else: the channel is already named, in bold, on the line
      // above. Kept as two keys rather than one shared string so a channel can say
      // something different later without unpicking the callers.
      description: {
        email: 'Before each of their upcoming bookings',
        sms: 'Before each of their upcoming bookings',
      },
      options: {
        on: 'Receives them',
        off: 'Asked to stop',
      },
      reason: {
        label: 'Why is this client receiving {{channel}} reminders again?',
        why: 'They had asked you to stop. Reversing a recorded request needs a written reason.',
        scope:
          'This goes onto the {{channel}} reminders record only — not the others — and it cannot be corrected or deleted later. Write what the client asked for and when.',
        hint: 'Do not enter health details, diagnoses, or personal circumstances. Describe the request, not the client. Anything you write here stays on this client’s record permanently.',
        counter: '{{count}} / {{max}}',
        required: 'Record why this client is receiving {{channel}} reminders again',
        tooLong: 'The reason cannot be longer than {{max}} characters',
        // Names no channel on purpose: the refusal identifies it only inside an English
        // sentence, and guessing which one it meant would attribute the amendment wrongly.
        conflict:
          'This client had asked to stop receiving reminders, so reversing that needs a written reason. Check that every channel you changed back on has one, then save again. Nothing has been recorded yet.',
      },
    },
    fields: {
      mobilePhone: 'Mobile phone',
      firstName: 'First name',
      lastName: 'Last name',
      additionalPhone: 'Landline phone',
      email: 'Email',
      facebook: 'Facebook',
      gender: 'Gender',
      occupation: 'Occupation',
      dateOfBirth: 'Date of birth',
      acquisitionSource: 'How did you hear about us',
      address: 'Address',
      branch: 'Registration branch',
      notes: 'Notes',
    },
    snackbars: {
      saved: 'Contact saved successfully!',
      saveFailed: 'Failed to save contact',
      notFound: 'Contact not found',
      mobileCheckFailed: 'Something went wrong while checking mobile number',
      contactLinked: 'Contact linked to the company',
      contactUnlinked: 'Contact removed from the company',
    },
    validation: {
      mobileInUse:
        'The mobile phone is already used by contacts {{names}}. You can use it again with a different first name, but BEWARE you will have two or more contacts with the same mobile phone.',
      mobileRequired: 'Mobile phone is required',
      mobileInvalid: 'Mobile phone is not valid',
      firstNameRequired: 'First name is required',
      genderInvalid: 'The selected value is not among the allowed values.',
      additionalPhoneInvalid: 'The landline number is not valid',
      emailInvalid: 'The email address is not valid',
      facebookInvalid: 'The profile URL is not valid',
    },
    communication: {
      employeeRequired: 'Employee is required',
      statusRequired: 'Status is required',
      dateRequired: 'Date is required',
      reminderRequired: 'Reminder date is required for Recall',
    },
    companiesSection: {
      linkCompany: 'Link company',
      columns: {
        legalName: 'Legal name',
        type: 'Type',
        roles: 'Roles',
      },
      unlink: {
        title: 'Unlink from company',
        content: 'Do you want to unlink the contact from the company {{companyName}}?',
        confirm: 'Unlink',
      },
    },
    communications: {
      list: {
        title: 'Communications ({{count}})',
        newButton: 'New communication',
        columns: {
          date: 'Date',
          employee: 'Employee',
          contact: 'Contact',
          status: 'Status',
          notes: 'Notes',
        },
        reminderTooltip: 'Reminder: {{date}}',
        noRows: 'No communications',
        loadFailed: 'Failed to load communications',
        deleted: 'Communication deleted successfully',
        deleteFailed: 'Failed to delete communication',
        deleteTitle: 'Delete communication',
        deleteContent: 'Are you sure you want to delete this communication?',
        deleteConfirm: 'Delete',
      },
      modal: {
        createTitle: 'New communication',
        editTitle: 'Edit communication',
        fields: {
          employee: 'Employee',
          date: 'Date',
          status: 'Status',
          recallDateTime: 'Reminder date & time',
          notes: 'Notes',
        },
        createSuccess: 'Communication created successfully',
        updateSuccess: 'Communication updated successfully',
        saveFailed: 'Failed to save communication',
        createButton: 'Create',
        saveButton: 'Save',
        cancelButton: 'Cancel',
      },
    },
  },
  leads: {
    listTitle: 'Leads',
    createOrder: 'Create order',
    columns: {
      lastName: 'Last name',
      firstName: 'First name',
      mobilePhone: 'Mobile',
      email: 'Email',
      leadManager: 'Lead manager',
      participants: 'Participants',
      lastOrder: 'Last order',
    },
    tooltips: {
      customer: 'Customer (has a completed order)',
      viewOrder: 'View order',
    },
  },
  employees: {
    listTitle: 'Employees',
    addEmployee: 'Add employee',
    erganiEmployeesButton: 'Ergani employees',
    availableSlots: 'Available slots: {{count}}',
    active: 'Active',
    inactive: 'Inactive',
    backToList: 'Employees list',
    createTitle: 'Add employee',
    columns: {
      lastName: 'Last name',
      firstName: 'First name',
      mobilePhone: 'Mobile phone',
      email: 'Email',
      specialties: 'Specialties',
      status: 'Status',
      isErganiEmployee: 'Ergani employee',
    },
    tabs: {
      basicInfo: 'Basic information',
      employmentInfo: 'Employment details',
      schedule: 'Schedule',
      attendance: 'Check-ins/Check-outs',
      communications: 'Communications',
    },
    steps: {
      basicInfo: 'Basic information',
      workInfo: 'Employment details',
    },
    fields: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      mobilePhone: 'Mobile phone',
      taxIdentificationNumber: 'Tax ID',
      taxOffice: 'Tax office',
      nationalInsuranceNumber: 'AMA',
      iban: 'IBAN',
      bank: 'Bank',
      socialSecurityNumber: 'AMKA',
      additionalMobilePhone: '2nd mobile phone',
      additionalPhone: 'Landline phone',
      facebook: 'Facebook',
      serviceGroup: 'Specialty',
      contractualWorkWeekHours: 'Working hours',
      grossWage: 'Gross wage',
      netWage: 'Net wage',
      contractStart: 'Contract start date',
      contractEnd: 'Contract end date',
      isErganiEmployee: 'Ergani employee',
    },
    placeholders: {
      fillIban: 'Fill in the IBAN',
    },
    tooltips: {
      mobileCheck: 'Check phone number usage in existing employees',
      contractEndAutoDeactivate: 'Auto-deactivate staff after contract end',
      contractEndDeactivates: 'After the contract end date the employee becomes inactive',
      edit: 'Edit',
      sendWorkCard: 'Emails the employee their work-card QR code. If they no longer have access to it, you can send it again from here.',
    },
    actions: {
      sendWorkCard: 'Send work card',
      previous: 'Previous',
      next: 'Next',
      check: 'Check',
      continue: 'Continue',
      newContact: 'New contact',
    },
    dialogs: {
      mobileCheck: {
        title: 'Mobile phone check',
        description: 'Check whether the mobile phone you want to enter is already used by one or more contacts',
      },
      contactExists: {
        title: 'Select contact',
        usedBy: 'The mobile phone <b>{{phone}}</b> is used by:',
        inEmployees: 'The following employees',
        inContacts: 'The following contacts',
        help: {
          title: 'What should I press?',
          continue: '<b>Continue</b> to pre-fill the data.',
          newContact:
            '<b>New contact</b> to create a contact with this mobile and a different name. Beware: you will have two or more contacts with the same mobile.',
          cancel: '<b>Cancel</b> to enter a new mobile phone.',
        },
      },
    },
    snackbars: {
      saved: 'Employee saved successfully!',
      saveFailed: 'Failed to save employee',
      notFound: 'Employee not found',
      ibanCheckFailed: 'Something went wrong while checking IBAN',
      mobileCheckFailed: 'Something went wrong while checking mobile number',
      workCardSent: "The work card was sent to the employee's email.",
      workCardSendFailed: 'Sending the work card failed.',
    },
    validation: {
      ibanInvalidFormat: 'IBAN must contain only Latin characters and digits',
      ibanInvalid: 'IBAN is not valid',
      dateInvalid: 'Please enter a valid date',
      dateRequired: 'Date is required',
      contractStartBeforeEnd: 'Contract start must precede the end date',
      contractEndAfterStart: 'Contract end must be after the start date',
      mobileRequired: 'Mobile phone is required',
      mobileInvalid: 'Mobile phone is not valid',
      firstNameRequired: 'First name is required',
      emailInvalid: 'The email address is not valid',
      ssnInvalid: 'AMKA is not valid',
      ninInvalid: 'AMA is not valid',
      tinInvalid: 'Tax ID is not valid',
      additionalPhoneInvalid: 'The landline number is not valid',
      phoneInUse: 'The number is already used',
      numberInvalid: 'Please enter a valid number',
      hoursMin: 'Minimum employment duration is 1 hour',
      hoursMax: 'Employment duration is not valid',
      hoursRequired: 'Employment duration is required',
      mobileInUse:
        'The mobile phone is already used by employee {{name}}. You can use it again with a different first name, but BEWARE you will have two or more employees with the same mobile.',
    },
    schedule: {
      title: 'Employee plan',
      sections: {
        current: 'Current plan',
        future: 'Scheduled plans',
        past: 'Plan history',
        overrideHistory: 'Emergency modifications history',
        activeOverrides: 'Emergency modifications',
        workHours: 'Working hours',
        breaks: 'Break',
        shift1: 'Schedule 1',
        shift2: 'Schedule 2',
      },
      empty: 'No active plan. Press "New plan" to create a plan.',
      fields: {
        title: 'Title:',
        titlePlaceholder: 'e.g. May 2025',
        startDate: 'Start date:',
        endDate: 'End date:',
        alternatingWeeks: 'Alternating schedules',
        selectMode: 'Select',
        days: 'Days',
      },
      modes: {
        sameHours: 'Same hours for every day',
        differentHours: 'Different hours for every day',
      },
      dayType: {
        working: 'Working day',
        nonWorking: 'Non-working day',
      },
      columns: {
        dayType: 'Day type',
        name: 'Title',
        planTitle: 'Plan title',
        overrideDate: 'Date',
        effectiveFrom: 'Start date',
        effectiveTo: 'End date',
      },
      currentItem: {
        startDate: 'Start date: <b>{{date}}</b>',
        endDate: 'End date: <b>{{date}}</b>',
      },
      overrideItem: {
        date: 'Date: <b>{{date}}</b>',
      },
      actions: {
        planOverride: 'Plan override',
        newPlan: 'New plan',
        update: 'Update',
        addShift: 'Add shift',
        addBreak: 'Add break',
        editPlan: 'Edit plan',
        today: 'Today',
        saveAsDayOff: 'Save as day off',
      },
      snackbars: {
        created: 'Plan saved successfully!',
        createdPlanPending: 'The plan was created, but saving working hours failed. Try again with Update.',
        updated: 'Plan updated successfully!',
        saveFailed: 'Failed to save plan',
        overlap: 'The plan overlaps with another plan',
        devBypassConflict: 'Dev: updated the existing overlapping plan (conflict bypass)',
        fetchFailed: 'Something went wrong.',
      },
      deleteDialog: {
        title: 'Delete plan',
        contentCurrent: 'Are you sure you want to delete the current plan?',
        contentScheduled: 'Are you sure you want to delete this scheduled plan?',
        contentPast: 'Are you sure you want to delete this plan from history?',
        contentOverride: 'Are you sure you want to delete this emergency schedule override?',
        cancel: 'Not yet',
        confirm: 'Yes, delete',
      },
      ergani: {
        sendButton: 'Send to ERGANI',
        sentChip: 'Sent to ERGANI',
        pendingChip: 'Pending submission',
        sentAtTooltip: 'Sent on {{date}}',
        snackbars: {
          sendSuccess: 'Weekly schedule sent to ERGANI successfully',
          sendFailed: 'Failed to send weekly schedule to ERGANI',
        },
      },
      override: {
        title: 'Plan override',
        dateLabel: 'Date to override:',
        dayOff: 'The selected date is non-working for the employee.',
        tooltips: {
          addShift: 'Add shift',
          deleteShift: 'Delete shift',
          addBreak: 'Add break',
          deleteBreak: 'Delete break',
        },
        snackbars: {
          searchFailed: 'Failed to search override',
          deleted: 'Override deleted',
          deleteFailed: 'Failed to delete override',
          saved: 'Override saved',
          saveFailed: 'Failed to save override',
        },
        ergani: {
          sendButton: 'Send to ERGANI',
          sentChip: 'Sent to ERGANI',
          pendingChip: 'Pending submission',
          snackbars: {
            sendSuccess: 'Successfully sent to ERGANI',
            sendFailed: 'Failed to send to ERGANI',
            alreadySent: 'Override already sent to ERGANI',
          },
        },
      },
      overrideHistory: {
        snackbars: {
          fetchFailed: 'Failed to load emergency modifications history',
        },
      },
      validation: {
        startRequired: "'From' time is required",
        endRequired: "'To' time is required",
        endAfterStart: "'To' time must be after 'from' time",
        nameRequired: 'Plan name is required',
        dateInvalid: 'Please enter a valid date',
        dateRequired: 'Date is required',
        planStartBeforeEnd: 'Plan start must precede the end date',
        planEndAfterStart: 'Plan end must follow the start date',
      },
    },
    plan: {
      backToEdit: 'Edit employee',
      notFound: 'Plan not found',
      legend: {
        work: 'Working hours',
        break: 'Breaks',
        today: 'Current day',
      },
    },
  },
  ergani: {
    employees: {
      title: 'Ergani employees',
      sendButton: 'Send to Ergani',
      sending: 'Sending...',
      selected_one: 'Selected',
      selected_other: 'Selected',
      columns: {
        scheduleStatus: 'Schedule in Ergani',
      },
      status: {
        sent: 'Has been sent',
        pending: 'Has not been sent',
      },
      snackbars: {
        fetchFailed: 'Failed to load employees',
        sendSuccess: 'Weekly schedule sent to ERGANI successfully',
        sendFailed: 'Failed to send to ERGANI',
        endpointUnavailable: 'The endpoint is not available yet. Please contact the backend team.',
        nothingToSend: 'No pending schedules to send',
        bulkSendSuccess_one: '{{count}} schedule sent to ERGANI successfully',
        bulkSendSuccess_other: '{{count}} schedules sent to ERGANI successfully',
        noScheduleForEmployee: '{{name}}: there is no active plan to send',
        sendFailedForEmployee: '{{name}}: failed to send the schedule to ERGANI',
      },
      attendanceButton: 'Check-in/check-out details',
      dayTimesAria: 'Check-in/check-out details',
    },
    attendance: {
      title: 'Check-in/check-out details',
      scheduledHours: 'ERGANI schedule',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      nonWorking: 'Non-working',
      emptyDay: 'There is no schedule and no recorded events for this day.',
      noSchedule: 'There is no schedule for this day.',
      noEmployees: 'No ERGANI employees found in the selected branch.',
      deviationWarning: 'More than 15 minutes off the declared schedule',
      onTime: 'Within 15 minutes of the declared schedule',
      today: 'Today',
      previousDay: 'Previous day',
      nextDay: 'Next day',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      fetchFailed: 'Failed to load check-in/check-out details',
    },
  },
  workCard: {
    title: 'Work Card',
    subtitle: "Please record an employee's check-in or check-out.",
    headerButton: 'Scan work card',
    resendInfo:
      'If an employee has no access to their QR code, it can be re-sent to their email from their employee page, under "Work details", using the "Send work card" button.',
    goToEmployees: 'Go to the employee list',
    actions: {
      scanQr: 'Scan QR code',
      manualEntry: 'Manual entry',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      dismiss: 'Cancel',
    },
    scanner: {
      title: 'Scan work card',
      starting: 'Starting camera...',
      startingHint: 'If the browser asks for permission, click Allow. Also check the camera icon next to the address bar.',
      hint: "Point the camera at the QR code of the employee's work card.",
      retry: 'Try again',
      errors: {
        noCamera: 'No camera was found on this device.',
        permissionDenied: 'Camera access was denied. Allow camera access in your browser settings and try again.',
        generic: 'The camera could not be started.',
      },
    },
    scanResult: {
      title: 'Scan successful',
      subtitle: 'Select whether the scan was a check-in or a check-out',
      employee: 'Employee name',
      time: 'Scan time',
    },
    manual: {
      title: 'Employee check-in / check-out',
      noEmployees: 'No ERGANI employees found',
      fields: {
        employee: 'Employee',
        employeePlaceholder: 'Select employee',
        employeeHelper: 'Search the employee by full name, tax id (AFM) or mobile phone',
        date: 'Date',
        time: 'Time',
      },
      validation: {
        employeeRequired: 'Select an employee',
        dateRequired: 'Date is required',
        dateInvalid: 'Invalid date',
        timeRequired: 'Time is required',
        timeInvalid: 'Invalid time',
        notInFuture: 'The time cannot be in the future',
      },
    },
    snackbars: {
      checkInSaved: 'Check-in saved successfully!',
      checkOutSaved: 'Check-out saved successfully!',
    },
    errors: {
      saveFailed: 'Submitting to ERGANI failed. Please try again.',
      noBranchSelected: 'Select a branch to record a check-in / check-out.',
      employeesLoadFailed: 'Failed to load the ERGANI employees.',
      employeesStillLoading: 'Employees are still loading, please try again in a moment.',
      invalidQr: 'The QR code is not a work card.',
      unknownEmployee: 'The QR code does not match an ERGANI employee of the selected branch.',
      employeeNotFound: 'Employee not found.',
      BRANCH_NOT_ASSOCIATED: 'The branch is not linked to an ERGANI branch. Complete the link under Settings > ERGANI.',
      EMPLOYEE_TAX_ID_MISSING: "The employee has no tax id (AFM). Fill it in on the employee's page.",
      EMPLOYEE_LAST_NAME_MISSING: "The employee has no last name. Fill it in on the employee's page.",
      EMPLOYEE_NOT_IN_ERGANI: 'The employee is not registered in ERGANI.',
      EMPLOYEE_EMAIL_MISSING: "The employee has no email. Fill it in on the employee's page.",
      ATTENDANCE_NOT_ALTERNATING:
        "The event is inconsistent with the employee's last record (a check-in must be followed by a check-out and vice versa).",
    },
  },
  services: {
    listTitle: 'Services',
    addService: 'Create service',
    reorderTitle: 'Change display order',
    available: 'Available',
    unavailable: 'Unavailable',
    active: 'Active',
    inactive: 'Inactive',
    minute: 'minute',
    minutes: 'minutes',
    cannotDisableLastActive: 'Cannot disable the only active service of this specialty',
    createTitle: 'Create service',
    backToList: 'Services list',
    columns: {
      name: 'Name',
      code: 'Code',
      netAmount: 'Amount excluding VAT',
      vatPercentage: 'VAT category',
      grossAmount: 'Total amount',
      duration: 'Duration',
      status: 'Status',
    },
    sections: {
      basicInfo: 'Basic information',
      amount: 'Amount',
      duration: 'Duration',
      publicBooking: 'Online booking',
    },
    fields: {
      name: 'Name',
      category: 'Category',
      status: 'Status',
      netAmount: 'Amount excluding VAT',
      grossAmount: 'Amount including VAT',
      vatPercentage: 'VAT category (%)',
      durationInMinutes: 'Service duration (minutes)',
      preparationDurationInMinutes: 'Preparation duration (minutes)',
      overlapAvailabilityDurationInMinutes: 'Overlap availability duration (minutes)',
      bufferDurationInMinutes: 'Extra service time (minutes)',
      offeredForPublicBooking: 'Available for online booking',
      comments: 'Notes',
    },
    placeholders: {
      durationServiceExample: 'e.g. 120',
      durationOtherExample: 'e.g. 10',
    },
    tooltips: {
      durationService: 'Time required by the procedure in minutes',
      preparation: 'Required preparation time before the procedure starts in minutes',
      overlap: 'Time of parallel customer service in minutes',
      buffer: 'Customer waiting time in minutes',
      offeredForPublicBooking:
        'Online booking availability is separate from the service status. The service is created inactive and is activated from the list.',
    },
    snackbars: {
      saved: 'Service saved successfully!',
      saveFailed: 'Failed to save service',
      notFound: 'Service not found',
      reorderSuccess: 'Order updated successfully',
    },
    validation: {
      nameRequired: 'Service name is required',
      vatInvalid: 'The selected value is not among the allowed values.',
      vatRequired: 'VAT percentage is required',
      durationPositive: 'Negative duration is not allowed',
      durationMin: 'Service duration must be at least 1 minute',
      durationRequired: 'Service duration is required',
      prepDurationMin: 'Preparation duration must be at least 1 minute',
      overlapMin: 'Overlap minutes must be at least 1',
      bufferMin: 'Buffer time must be at least 1 minute',
    },
    reorder: {
      title: 'Change services display order',
      description:
        'Adjust the display order of services on the online booking page. Changes are saved automatically and applied immediately.',
      empty: 'No services have been registered yet',
    },
  },
  orders: {
    listTitle: 'Orders',
    createOrder: 'Create order',
    backToList: 'Orders list',
    title: 'Order',
    statusLabel: 'Order status:',
    completeButton: 'Complete',
    columns: {
      orderNumber: 'Order #',
      createdAt: 'Created on',
      lead: 'Lead',
      company: 'Company',
      leadManager: 'Lead Manager',
      participants: 'Participants',
      totalAmount: 'Amount incl. VAT',
      status: 'Order status',
    },
    clone: {
      title: 'Clone order',
      content: 'Do you want to clone the order {{orderId}}?',
      success: 'Order {{orderId}} cloned successfully',
    },
    totals: {
      label: 'Total (incl. VAT)',
      error: 'Unable to load total',
    },
    create: {
      title: 'Create order',
      branch: 'Select branch',
      allBranches: 'All branches',
      searchAccordion: 'Search contact{{ companyPart }}',
      companyPart: '/company',
      contact: 'Contact',
      newContact: 'Create new contact',
      mobilePhone: 'Mobile phone',
      firstName: 'First name',
      lastName: 'Last name',
      companyOrder: 'Company order',
      contactCompany: 'Contact company',
      snackbars: {
        contactExists: 'Contact already exists',
        contactCreateFailed: 'Failed to create contact',
        saveFailed: 'Failed to save order',
      },
    },
    sections: {
      basicInfo: 'Basic information',
      items: 'Items',
      payments: 'Payments',
      otherInfo: 'Other information',
    },
    fields: {
      client: 'Customer',
      company: 'Company',
      effectiveFrom: 'Creation date',
      expiresOn: 'Expiry date',
      leadManager: 'Employee (Lead Manager)',
      participants: 'Participants',
      notes: 'Notes',
      paymentMethod: 'Payment method:',
      totalDiscountAmount: 'Total discount (€):',
      totalDiscountPercentage: 'Total discount (%):',
      totalAmount: 'Total amount:',
    },
    items: {
      service: 'Service',
      netAmount: 'Amount excl. VAT',
      vat: 'VAT',
      discountAmount: 'Discount €',
      discountPercentage: 'Discount %',
      total: 'Total',
    },
    payments: {
      emptyState: 'Add items and the payment plan will be created',
      title: 'Payment {{number}}',
      dueBy: 'Due by:',
      method: 'Payment method:',
      total: 'Total',
      edit: 'Edit payment',
      editTitle: 'Edit payment {{number}}',
      fields: {
        paymentMethod: 'Payment method',
        dueDate: 'Due date',
      },
      methodDisabled: 'Disabled',
      validation: {
        methodRequired: 'Payment method is required',
        dueDateRequired: 'Due date is required',
      },
      updateSuccess: 'Payment updated',
    },
    selectPaymentMethod: 'Select payment method',
    snackbars: {
      updated: 'Order updated',
      itemAdded: 'Service added',
      itemDeleted: 'Service removed',
      saveFailed: 'Failed to save order',
      genericFail: 'Something went wrong.',
      notFound: 'Order not found',
      invoiceCancelled: 'Invoice cancelled',
      invoiceCancelledAtAade: 'Invoice cancelled at AADE',
      draftDiscarded: 'Draft discarded',
      invoiceIssued: 'Invoice issued',
      invoiceRejected: 'AADE rejected the invoice',
      invoiceUnconfirmed: 'AADE did not confirm the issuance. Try again.',
      invoiceFoundCancelled: 'The invoice was already cancelled at AADE.',
    },
    delete: {
      title: 'Delete order',
      content: 'Do you want to delete the order #{{orderId}}?',
    },
    completeStatus: {
      title: 'Complete order',
      content: 'After completing the order, you will only be able to manage invoices. Are you sure you want to continue?',
      confirmButton: 'Yes, complete',
      cancelButton: 'Not yet',
    },
    invoicePrint: {
      invoiceTitle: 'Service Invoice',
      receiptTitle: 'Service Receipt',
      titles: {
        SERVICE_RECEIPT: 'Service Receipt',
        RETAIL_CREDIT_NOTE: 'Retail Credit Note',
        SERVICE_INVOICE: 'Service Invoice',
        SERVICE_CREDIT_INVOICE: 'Credit Invoice',
      },
      number: 'Number',
      noNumber: 'No number',
      draftWatermark: 'DRAFT / NOT VALID',
      issued: 'Issued',
      statuses: {
        DRAFT: 'Draft',
        PENDING: 'Pending',
        ISSUED: 'Issued',
        FAILED: 'Rejected',
        CANCELLED: 'Cancelled',
        REVERSED: 'Credited',
        DISCARDED: 'Discarded',
      },
      missingCompany: 'No company linked',
      noSeries: 'No series',
      vatNumber: 'VAT No.',
      taxOffice: 'Tax office',
      invoiceDetails: 'Invoice Details',
      receiptDetails: 'Receipt Details',
      customerDetails: 'Customer Details',
      date: 'Date',
      dueDate: 'Due date',
      paymentMethod: 'Payment Method',
      finalTotal: 'Final Total',
      columns: {
        service: 'Service',
        valueBeforeDiscount: 'Value before Discount',
        netAmount: 'Net Amount',
        vat: 'VAT',
        discount: 'Discount',
        total: 'Total',
      },
      myData: {
        title: 'myDATA connection',
        mark: 'MARK',
        uid: 'Invoice UID',
        authenticationCode: 'Authentication code',
      },
    },
    validation: {
      totalDiscountRequired: 'Total discount is required',
      totalAmountRequired: 'Total amount is required',
      currencyInvalid: 'The selected value is not among the allowed values.',
      serviceRequired: 'Service is required',
      netAmountRequired: 'Amount excluding VAT is required',
      vatPercentageRequired: 'VAT category is required',
      itemTotalRequired: 'Total is required',
      statusRequired: 'Order status is required',
      effectiveFromRequired: 'Creation date is required',
      clientRequired: 'Customer is required',
      atLeastOneItem: 'The order must include at least one service',
      mobileRequired: 'Mobile phone is required',
      mobileInvalid: 'Mobile phone is not valid',
      amountRequired: 'Amount is required',
      amountValueRequired: 'Amount is required',
      amountTypeRequired: 'Amount type is required',
      discountRequired: 'Discount is required',
      discountTypeRequired: 'Discount type is required',
      discountAmountMin: 'The discount must not be less than {{min}}€',
      discountAmountMax: 'The discount must not exceed {{max}}€',
      discountPercentageMin: 'The discount must not be less than {{min}}%',
      discountPercentageMax: 'The discount must not exceed {{max}}%',
      vatPercentagePositive: 'VAT category must be greater than 0',
      vatPercentageInteger: 'VAT category must be a whole number',
      grossTotalPositive: 'The total must be greater than 0',
      grossTotalMax: 'The total must not exceed {{max}}€',
    },
    drawer: {
      title: 'Invoices for {{invoiceName}}',
      subtitle: {
        active: 'Active invoice',
        previous: 'Previous invoices',
      },
      fields: {
        status: 'Status',
        sequence: {
          label: 'Numbering sequence',
          emptyState: 'Select numbering sequence',
        },
        dueDate: 'Date',
        issuedDate: 'Issued date',
      },
      viewDraft: 'View draft',
      previewTitle: 'Draft preview',
      printPreview: 'Print',
      noInvoiceSeries:
        'You have not created any numbering series yet. You can create one by clicking the purple settings button on the right.',
      invoiceLoadFailed: 'Invoices could not be loaded. Invoice actions are unavailable until you try again.',
      noB2bSeries:
        'Invoices to businesses are issued through the e-invoicing provider, which is not available yet. The draft stays and can be issued later.',
      aadeNotConnected: 'This company has no myAADE credentials. Add them from invoicing settings before issuing invoices.',
      goToInvoicingSettings: 'Go to invoicing settings',
      noDraft: {
        description: 'There is no invoice for this payment yet. Create a draft to choose its series and issue it.',
        create: 'Create draft',
      },
      generateInvoice: 'Issue invoice',
      viewInvoice: 'View',
      manageInvoices: 'Manage invoices',
      invoicesDisabledNotCompleted: 'Invoices are only available for completed orders',
      cancelInvoice: 'Cancel',
      discardDraft: 'Discard draft',
      confirmIssuance: 'Confirm issuance',
      retryIssuance: 'Try issuing again',
      awaitingMark: 'MARK pending',
      confirmations: {
        issue: {
          title: 'Issue invoice',
          content:
            'Are you sure you want to issue this invoice? It will get a number and be sent to AADE as a legal document, so no changes are allowed after that. The payment method & due date will be printed on the invoice.',
          confirm: 'Issue invoice',
          cancel: 'Do not issue',
        },
        cancel: {
          title: 'Cancel invoice',
          content: 'Are you sure you want to cancel this invoice? The cancellation is sent to AADE.',
          confirm: 'Cancel invoice',
          cancel: 'Do not cancel',
        },
        cancelFailed: {
          title: 'Cancel invoice',
          content: 'This invoice does not exist at AADE. Cancelling frees the payment for a new invoice; its number stays unused.',
          confirm: 'Cancel invoice',
          cancel: 'Do not cancel',
        },
        cancelPending: {
          title: 'Cancel invoice',
          content:
            'AADE is checked first for whether the invoice was registered. If it was, it is cancelled at AADE; otherwise it is cancelled here and its number stays unused.',
          confirm: 'Cancel invoice',
          cancel: 'Do not cancel',
        },
        discard: {
          title: 'Discard draft',
          content: 'The draft will be discarded. It has no number yet, so numbering is not affected.',
          confirm: 'Discard draft',
          cancel: 'Keep draft',
        },
      },
      pendingInvoice: {
        notice: 'AADE did not confirm the last transmission. “Confirm issuance” checks the invoice at AADE and completes its issuance.',
      },
      failedInvoice: {
        title: 'AADE rejected this invoice',
        cancelHint: 'If it cannot be fixed, cancel it: the payment is freed and the number stays unused.',
      },
      issuedInvoice: {
        notice: 'Issued and sent to AADE (myDATA)',
      },
      cancelledInvoice: {
        issuedDate: 'Issued',
        cancelledDate: 'Cancelled',
        discardedDate: 'Discarded',
        aadeCancellationMark: 'AADE cancellation MARK',
      },
      errors: {
        outcomeUnconfirmed: 'We did not get a confirmation of the outcome. The view was refreshed with the current state of the invoice.',
        aadeCredentialsMissing: "This invoice's company has no myAADE credentials. Add them from invoicing settings and try again.",
      },
    },
  },
  bookings: {
    calendarTitle: 'Calendar',
    listTitle: 'Bookings',
    backToCalendar: 'Calendar',
    columns: {
      contact: 'Customer',
      dateTime: 'Date/Time',
      service: 'Service',
      amount: 'Amount',
      employee: 'Employee',
      status: 'Booking status',
    },
    delete: {
      title: 'Delete booking',
      content: 'Do you want to delete the booking {{bookingId}}?',
    },
    toolbar: {
      list: 'Bookings list',
      newBooking: 'New booking',
      today: 'Today',
      filters: 'Filters',
      filtersLabel: 'Filters:',
      filtersTitle: 'Booking filters',
      apply: 'Apply',
      filterChip: {
        contact: 'Customer: {{name}}',
        service: 'Service: {{name}}',
        status: 'Status: {{name}}',
      },
    },
    drawer: {
      service: 'Service',
      contact: 'Customer',
      status: 'Booking status',
    },
    validation: {
      dateRequired: 'Date is required',
      timeRequired: 'Time is required',
      employeeRequired: 'Employee selection is required',
      firstNameRequired: 'First name is required',
      mobileRequired: 'Mobile phone is required',
      mobileInvalid: 'Mobile phone is not valid',
      emailRequired: 'Customer email is required',
      emailInvalid: 'The email address is not valid',
      serviceRequired: 'Service selection is required',
    },
    snackbars: {
      created: 'Booking created',
      updated: 'Booking updated',
      deleted: 'Booking deleted',
      saved: 'Booking saved.',
      cancelled: 'Booking cancelled.',
      saveFailed: 'Something went wrong.',
      notFound: 'Booking not found',
      mobileCheckFailed: 'Something went wrong while checking the mobile phone',
      contactCreateFailed: 'Failed to create contact',
      pickContactWarning: 'Select an existing contact or create a new one.',
    },
    form: {
      backToList: 'Bookings list',
      titleEdit: 'Edit booking',
      titleNew: 'New booking',
      statusPlaceholder: 'Booking status',
      statusLabel: 'Booking status',
      completedAlert: 'The booking is completed. To edit it, change the status of the linked',
      completedAlertLink: 'order',
      date: 'Date',
      time: 'Time',
      employee: 'Employee',
      services: 'Services',
      comments: 'Notes',
      searchExistingContact: 'Search existing contact',
      newContactSection: 'Create new contact',
      mobilePhone: 'Mobile phone',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      clientEmail: 'Customer email',
      notifyClient: 'Notify customer',
      notifyClientTooltip:
        "If you enable customer notifications, when the booking transitions to 'Active' status or is cancelled, an email with the booking details will be sent to the customer.",
      save: 'Save',
      create: 'Create',
      cancelButton: 'Cancel',
      cancelBooking: 'Cancel booking',
      cancelDialogTitle: 'Cancel booking',
      cancelDialogContent: 'Are you sure you want to cancel this booking?',
      clientReminders: {
        title: "This customer's reminder record",
        loading: 'Loading the reminder record…',
        unavailable: "This customer's reminder record could not be loaded.",
        smsOn: 'SMS reminders: on',
        smsOff: 'SMS reminders: off — the customer asked for these to stop',
        emailOn: 'Email reminders: on',
        emailOff: 'Email reminders: off — the customer asked for these to stop',
        confirmationsNote: 'This record does not affect booking confirmation or cancellation emails.',
        permanenceNote: 'A change to this record is permanently recorded against the user who makes it.',
        changeLink: "Open the customer's page to change this",
      },
    },
  },
  statistics: {
    title: 'Statistics',
    totalRevenue: 'Total revenue',
    monthlyRevenue: 'Monthly revenue',
    compareLastYear: 'vs. same period last year',
    noData: 'No data available',
    revenueByMonth: 'Revenue per month',
    revenueByService: 'Revenue per service',
    revenueByServiceCategory: 'Revenue per service category',
    revenueByEmployee: 'Revenue per employee',
    revenueByEmployeeService: 'Revenue per employee per service',
    completedOnlyTooltip: 'Only completed orders',
    dateRange: {
      start: 'From',
      end: 'To',
    },
  },
  dashboard: {
    listTitle: 'Overview',
    period: {
      label: 'Time period',
      last7: 'Last 7 days',
      last30: 'Last 30 days',
      last365: 'Last 365 days',
    },
    activeClients: {
      title: 'Active customers',
      tooltip: 'Your customers who have completed orders',
    },
    noShow: {
      title: 'No-show ratio',
      tooltip:
        'The %NSA ratio (No Show Appointments) is a metric that measures the percentage of scheduled appointments that did not take place because the customer did not show up, without having cancelled the appointment.',
    },
    availableEmployees: {
      title: 'Available today',
      empty: 'No available employees.',
    },
    nextAppointments: {
      title: "Today's upcoming appointments",
      empty: 'No appointments today.',
      defaultService: 'Service',
      with: 'with {{name}}',
    },
    pendingAppointments: {
      title: 'Unconfirmed appointments',
      empty: 'No unconfirmed appointments',
      confirmTooltip: 'Confirm appointment',
      cancelTooltip: 'Cancel appointment',
      openTooltip: 'Open appointment',
      confirmedSnackbar: 'Appointment confirmed.',
      cancelledSnackbar: 'Appointment cancelled.',
      confirmFailed: 'Failed to confirm appointment',
      cancelFailed: 'Failed to cancel appointment',
    },
    topClients: {
      title: 'Top 10 customers',
      empty: 'No data available',
      loadFailed: 'Failed to load customers',
      sortVisits: 'Visits',
      sortPayments: 'Payments',
    },
    topServices: {
      title: 'Top 10 services',
      empty: 'No data available',
      loadFailed: 'Failed to load services',
      sortCount: 'Quantity',
      sortCost: 'Revenue',
    },
    notices: {
      loadFailed: {
        title: 'Some invoicing setup checks could not be loaded',
        description: 'Setup notices may be incomplete. Try loading them again.',
        cta: 'Try again',
      },
      noTenantCompanies: {
        title: 'No company registered',
        description: 'Registering a company is required to issue invoices in your Orders.',
        cta: 'Go to Companies',
      },
      unlinkedBranches: {
        title: 'Some of your branches are not linked to your companies',
        description: 'Linking is required to issue invoices in your Orders.',
        cta: 'Go to Branches',
      },
    },
  },
  apiErrors: {
    erganiInvalidCredentials: 'Invalid ERGANI username or password',
    branchNameAlreadyExists: 'A branch named "{{branchName}}" already exists. Please choose a different name.',
    addressIncomplete: 'The address is missing required details ({{missingComponents}}). Please pick another suggestion.',
    erganiUnavailable: 'ERGANI is unavailable right now. Please try again later.',
    erganiBranchAlreadyAssociated: 'This store is already connected to another ERGANI branch.',
    activeBranchLimitReached: 'You have reached the maximum number of active branches ({{branchLimit}}). Contact us for an upgrade.',
    activeEmployeeLimitReachedForTier:
      "You have reached the active employee limit for the '{{tierCode}}' tier ({{employeeLimit}}). Upgrade your plan.",
    orderStatusNotEligible: "This order's status no longer allows invoicing.",
    orderBranchNoCompany: "This order's branch isn't linked to a company.",
    invoicing: {
      AADE_CREDENTIALS_INCOMPLETE: 'Fill in the myAADE username and password together.',
      AADE_CREDENTIALS_IN_USE:
        "This company has pending invoices that need these credentials. Complete or cancel the company's pending invoices before removing its AADE credentials.",
      AADE_CREDENTIALS_INVALID: 'AADE rejected the credentials. Check the username and password.',
      AADE_CREDENTIALS_MISSING: "Issuing directly to AADE needs the company's myAADE credentials.",
      FISCAL_PROVIDER_NOT_ACTIVE: 'To choose the provider, the company needs an active account with it.',
      FISCAL_PROVIDER_NOT_READY:
        'Some company details are missing before connecting to the provider. Refresh the page to see what is needed.',
      FISCAL_PROVIDER_TAX_ID_NOT_CONFIRMED: "The company's tax ID changed while the form was open. Check the tax ID and confirm again.",
      FISCAL_PROVIDER_CONTACT_EMAIL_TAKEN:
        "This email is already used for another company's account with the provider. Use a different email.",
      FISCAL_PROVIDER_CONTACT_PHONE_INVALID: 'The contact phone is not a valid phone number. Check it and try again.',
      FISCAL_PROVIDER_ALREADY_ACTIVE: 'The company already has an active account with the provider.',
      FISCAL_PROVIDER_ACTIVATION_REFUSED:
        'The provider refused to create the account. Support has been notified; trying again would produce the same answer.',
      FISCAL_PROVIDER_ACTIVATION_NOT_STARTED: 'Sign-up with the provider has not been started for this company.',
      FISCAL_PROVIDER_ACTIVATION_ALREADY_STARTED: 'Sign-up with the provider has already been started for this company. Refresh the page.',
      FISCAL_PROVIDER_ACTIVATION_AWAITING_SUPPORT: 'Sign-up with the provider is with support; there is nothing for you to do.',
      WRAPP_PARTNERS_API_ERROR: 'Could not reach the provider. Please try again later with "Continue".',
      NOT_FOUND: 'This item no longer exists or no longer belongs to your account. Refresh the page.',
      BAD_REQUEST: 'Some details are not valid. Check the fields and try again.',
      PROVIDER_SERIES_NOT_SUPPORTED:
        'This type is issued through the e-invoicing provider, which needs an active account for the company. It is not available yet.',
      B2C_ISSUANCE_DISABLED: 'This company does not issue retail receipts here; it uses its own system.',
      B2B_ISSUANCE_DISABLED: "This company does not issue invoices to businesses here. Turn them on in the company's issuing settings.",
      CREDIT_NOTE_SERIES_NOT_ALLOWED: 'Credit-note series are created automatically with their original series.',
      SERIES_CODE_ALREADY_EXISTS: 'This code is already used by another series of this type.',
      SERIES_CHANNEL_MISMATCH: 'This series belongs to another issuing method and cannot be used.',
      SERIES_COMPANY_MISMATCH: 'This series belongs to another company. Choose another series.',
      SERIES_AUDIENCE_MISMATCH: "This series does not match the invoice's customer. Choose another series.",
      SERIES_NOT_ACTIVE: 'This series is no longer active. Choose another series.',
      NO_SERIES_SELECTED: 'Choose a numbering series.',
      PROVIDER_ISSUANCE_NOT_SUPPORTED: 'Issuing through the e-invoicing provider is not available yet.',
      DOCUMENT_TYPE_MISMATCH: 'The draft is out of date. Choose the numbering series again.',
      BRANCH_MISSING_AADE_CODE: "The branch's AADE branch code is missing.",
      COUNTERPART_VAT_MISSING: "The invoice's customer needs a VAT number.",
      LINE_NAME_EMPTY: 'Line {{lineNumber}} needs a name.',
      VAT_EXEMPTION_CODE_MISSING: 'Line {{lineNumber}} has 0% VAT, which cannot be issued yet.',
      LINE_VAT_MISMATCH:
        'The amounts of this document do not add up. Discard the draft and create it again from the order. (Line {{lineNumber}}: expected {{expected}}, found {{actual}})',
      TOTAL_NET_MISMATCH:
        'The amounts of this document do not add up. Discard the draft and create it again from the order. (Net total: expected {{expected}}, found {{actual}})',
      TOTAL_VAT_MISMATCH:
        'The amounts of this document do not add up. Discard the draft and create it again from the order. (VAT total: expected {{expected}}, found {{actual}})',
      TOTAL_GROSS_MISMATCH:
        'The amounts of this document do not add up. Discard the draft and create it again from the order. (Total: expected {{expected}}, found {{actual}})',
      TOTAL_NOT_POSITIVE:
        'The amounts of this document do not add up: it has no lines or its total is not positive. Discard the draft and create it again from the order.',
      INVOICE_NOT_DRAFT: 'This invoice changed in the meantime. The view was refreshed.',
      INVOICE_NOT_ISSUABLE: 'This invoice changed in the meantime. The view was refreshed.',
      INVOICE_NOT_CANCELLABLE: 'This invoice changed in the meantime. The view was refreshed.',
      INVOICE_ALREADY_CANCELLED: 'This invoice is already cancelled. The view was refreshed.',
      ACTIVE_INVOICE_EXISTS: 'This payment already has an active invoice. The view was refreshed.',
      ORDER_NO_PAYMENT: 'This order has no payment to invoice.',
      INVOICE_OUTCOME_UNKNOWN: 'AADE could not be checked. Try again shortly.',
      PROVIDER_CANCELLATION_NOT_ALLOWED: 'This invoice was issued through the provider and can only be corrected with a credit note.',
      PAYMENT_METHOD_NOT_SET: "Set the payment's method first, then try issuing again.",
      AADE_CANCELLATION_FAILED: 'AADE refused the cancellation. The invoice stays issued.',
      AADE_CANCELLATION_UNKNOWN: 'AADE did not confirm the cancellation. Try again.',
    },
  },
  validation: {
    address: {
      required: 'Address is required',
      notSpecificEnough: 'Please pick a street or street number from the suggestions',
    },
    money: {
      amountInvalid: 'Please enter a valid number',
      amountRequired: 'The amount is required',
      amountNonNegative: 'Negative values are not allowed',
      currencyRequired: 'The currency is required',
    },
    logo: {
      fileRequired: 'Please choose a file',
      fileSizeMax: 'The file size must not exceed {{max}}MB',
      fileTypeImage: 'The file must be PNG or JPEG',
      fileExtensionInvalid: 'Invalid file extension',
      extensionInvalidWithFile: 'Invalid file extension: {{ext}}. Allowed: .png, .jpg, .jpeg',
      typeInvalid: 'Invalid file type',
      sizeMaxWithCurrent: 'The file size must not exceed 5MB (current: {{size}}MB)',
      imageTooSmall: 'The image is too small: {{width}}×{{height}}px (minimum: {{min}}px on the shortest side)',
      imageTooLarge: 'The image is too large: {{width}}×{{height}}px (maximum: {{max}}px on the longest side)',
      invalidImageFile: 'Invalid image file',
      readError: 'Error while reading the image',
      qualityExcellent: 'Excellent quality',
      qualityGood: 'Good quality',
      qualityAcceptable: 'Acceptable quality (higher resolution recommended)',
      uploaded: 'Logo uploaded successfully',
      uploadFailed: 'Upload failed. Please try again.',
    },
  },
  filters: {
    selected_one: '{{count}} selected',
    selected_other: '{{count}} selected',
    dateRangePlaceholder: 'From - To',
    lastOrder: {
      placeholder: 'From - To/Status',
      date: 'Date',
      status: 'Status',
      all: 'All',
    },
  },
  settings: {
    listTitle: 'Settings',
    tabs: {
      publicBooking: 'Online booking',
      serviceGroups: 'Specialties',
      acquisitionSources: 'Acquisition sources',
      orderStatuses: 'Order statuses',
      ergani: 'ERGANI',
      serviceCategories: 'Service categories',
      branches: 'Branches',
      companies: 'My companies',
      invoicing: 'Invoicing',
      tenants: 'Tenants',
      calendar: 'Calendar',
    },
    item: {
      available: 'Available',
      unavailable: 'Unavailable',
    },
    tenants: {
      title: 'Tenants',
      addButton: 'Add tenant',
      empty: 'No tenants found',
      modalTitleAdd: 'Add tenant',
      modalTitleEdit: 'Edit tenant',
      featurePlaceholder: 'Choose features',
      fields: {
        name: 'Name',
        alias: 'Alias',
        tier: 'Tier',
        features: 'Features',
        firstName: 'Tenant Admin first name',
        lastName: 'Last name',
        email: 'Email',
        platformAdminEmail: 'Platform Admin Email',
      },
      validation: {
        nameRequired: 'Name is required',
        aliasRequired: 'Alias is required',
        tierRequired: 'Tier is required',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        emailInvalid: 'Invalid email',
        emailRequired: 'Email is required',
      },
      snackbars: {
        created: 'Tenant created successfully!',
        createFailed: 'Failed to create tenant',
        updated: 'Tenant updated successfully!',
        updateFailed: 'Failed to update tenant',
        copied: 'Copied!',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
      },
      onboardResult: {
        title: 'Tenant created',
        warning: 'Passwords will not appear again after closing this dialog. Note them down before continuing.',
        tenantPasswordLabel: 'Tenant admin password',
        platformPasswordLabel: 'Platform admin password',
        clickHere: 'Click Here',
        show: 'Show',
        hide: 'Hide',
        copy: 'Copy',
        close: 'Close',
      },
    },
    publicBooking: {
      title: 'Online bookings',
      branding: {
        title: 'Company branding',
      },
      nameForm: {
        label: 'Company name',
        helperText: 'The name shown to customers during online bookings',
        placeholder: 'Enter the name',
        charactersHelper: '{{count}}/{{max}} characters:',
        save: 'Save',
        updated: 'Name updated successfully',
        saveError: 'An error occurred while saving',
      },
      logoUpload: {
        title: 'Upload new logo',
        formats: 'Accepted formats: PNG, JPEG • Maximum size: 5MB • Dimensions: 100-3000px',
        chooseFile: 'Choose file',
        clear: 'Clear',
        publish: 'Publish',
      },
      logoPreview: {
        defaultCompany: 'Company',
        currentTitle: 'Current logo',
        previewTitle: 'Preview',
        previewBadge: 'Preview',
        previewLogoAlt: 'Logo preview',
        companyLogoAlt: '{{name}} logo',
        howItWillAppear: 'This is how your logo will appear on the bookings page',
        emptyPreview: 'No file selected',
        emptyCurrent: 'No logo uploaded',
        urlNote: 'Note: URLs expire after 10 minutes and are refreshed automatically',
      },
      bookingSummary: {
        previewTitle: 'Booking page preview',
        previewBadge: 'Preview',
        howItWillAppear: 'This is how your logo will appear on the bookings page',
        servicesTitle: 'Selected services',
        durationOneHour: '1 hour',
        totalCost: 'Total cost',
        sampleService: 'Haircut and styling',
      },
      wizardSteps: {
        title: 'Booking steps',
        description: 'Configure which steps appear on the online bookings page.',
        showEmployeeLabel: 'Show employee selection',
        showEmployeeHelper: 'When enabled, customers can select a specific employee during booking.',
        emailRequiredLabel: 'Require customer email',
        emailRequiredHelper:
          'When disabled, customers can book without an email. Bookings without email will not receive confirmation emails and will remain pending.',
        loadFailed: 'Failed to load settings',
        savedSuccess: 'Settings saved successfully',
        saveFailed: 'Failed to save settings',
      },
      ownerNotifications: {
        title: 'Owner notifications',
        description: 'Get an email when a customer books from the online bookings page. Does not apply to back-office bookings.',
        enableLabel: 'Send new-appointment notifications',
        enableHelper: 'Get an email when a customer books from online bookings. Does not apply to back-office bookings.',
        onlyConfirmedLabel: 'Only for confirmed bookings',
        onlyConfirmedHelper:
          'When on, you are emailed only after the customer confirms the booking. Turn it off to also be notified for pending (unconfirmed) bookings.',
        recipientEmailLabel: 'Recipient email',
        recipientEmailPlaceholder: 'Enter email',
        recipientEmailHelper: 'The address notifications will be sent to.',
        emailRequired: 'Email is required when a notification is enabled',
        emailInvalid: 'The email address is not valid',
        save: 'Save',
        savedSuccess: 'Settings saved successfully',
        saveFailed: 'Failed to save settings',
        loadFailed: 'Failed to load settings',
      },
    },
    calendarDisplay: {
      title: 'Calendar',
      panelTitle: 'Calendar display',
      description: 'Controls how the bookings calendar is shown. It does not change availability, bookings, or online booking.',
      startTime: 'From',
      startTimeHelper: 'First hour shown on the calendar',
      endTime: 'To',
      endTimeHelper: 'Last hour shown on the calendar',
      slotMinutes: 'Interval',
      slotMinutesOption: '{{minutes}} minutes',
      widenNote: 'If a booking falls outside this range, the view widens automatically for that day so the booking stays visible.',
      save: 'Save',
      savedSuccess: 'Settings saved successfully',
      saveFailed: 'Failed to save settings',
      loadFailed: 'Failed to load settings',
      validation: {
        startRequired: 'Start time is required',
        endRequired: 'End time is required',
        endAfterStart: 'End time must be after start time',
        slotRequired: 'Interval is required',
        slotInvalid: 'Choose 10, 15, 30 or 60 minutes',
      },
    },
    ergani: {
      reconnectTitle: 'Reconnect to ERGANI',
      initialTitle: 'Business connection details',
      businessDetailsTitle: 'Business details',
      branchesTitle: 'Branches',
      successChip: 'Successfully connected to ERGANI',
      disconnectButton: 'Disconnect',
      disconnectDialog: {
        title: 'Disconnect',
        content: 'Are you sure you want to disconnect the ERGANI account?',
        confirm: 'Disconnect',
      },
      reconnectButton: 'Connect with new credentials',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      connectButton: 'Connect',
      fields: {
        username: 'Username',
        password: 'Password',
        companyName: 'Company name',
        taxId: 'Tax ID',
        erganiBranch: 'Branch',
        connectedStore: 'Connected to store',
        selectStore: 'Select',
      },
      snackbars: {
        connected: 'Connection to ERGANI completed successfully!',
        connectFailed: 'Connection to ERGANI failed',
        settingsSaved: 'Settings saved successfully!',
        settingsSaveFailed: 'Failed to save settings',
        mappingSaved: 'Branch connection saved',
        mappingRemoved: 'Branch connection removed',
        mappingSaveFailed: 'Failed to save the branch connection',
        loadFailed: 'Failed to load ERGANI details',
      },
      validation: {
        usernameRequired: 'Username is required',
        passwordRequired: 'Password is required',
        storeIdRequired: 'Number is required',
      },
    },
    serviceCategories: {
      title: 'Service categories',
      addButton: 'Add new category',
      reorderButton: 'Change display order',
      empty: 'No service categories found',
      tabHeading: 'Services in the {{name}} category',
      tabEmpty: 'There are no services in this category',
      inactiveChip: 'Inactive',
      editAction: 'Edit',
      modalTitleEdit: 'Edit category',
      modalTitleAdd: 'Add category',
      fields: {
        name: 'Category name',
        services: 'Services',
        servicePlaceholder: 'Pick a service',
      },
      validation: {
        nameRequired: 'Category name is required',
        nameDuplicate: 'A category with this name already exists',
      },
      snackbars: {
        saved: 'Category saved successfully!',
        updated: 'Category updated successfully!',
        deleted: 'Category deleted successfully!',
        saveFailed: 'Failed to save category',
        updateFailed: 'Failed to update category',
        deleteFailed: 'Failed to delete category',
        reorderSuccess: 'Order updated successfully',
      },
      deleteDialog: {
        title: 'Confirm deletion',
        content: 'Are you sure you want to delete the category {{name}}?',
        confirm: 'Delete',
      },
      reorder: {
        title: 'Change category display order',
        description: 'Adjust the display order of service categories. Changes are saved automatically and applied immediately.',
        empty: 'No categories have been registered yet',
        close: 'Close',
      },
      services_one: '{{count}} service',
      services_other: '{{count}} services',
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
    },
    orderStatuses: {
      title: 'Order statuses',
      defaultLabel: 'Default order status',
      orderTitle: 'Order status sequence',
      active: 'Active',
      inactive: 'Inactive',
      snackbars: {
        updated: 'Status updated successfully',
        updateFailed: 'Something went wrong.',
      },
    },
    acquisitionSources: {
      title: 'Where you found us',
      addButton: 'Add source',
      empty: 'No sources found',
      modalTitleEdit: 'Edit source',
      modalTitleAdd: 'Add source',
      fields: {
        name: 'Source',
      },
      validation: {
        nameRequired: 'The source is required',
      },
      snackbars: {
        saved: 'Source saved successfully!',
        updated: 'Source updated successfully!',
        deleted: 'Source deleted successfully!',
        saveFailed: 'Failed to save source',
        updateFailed: 'Failed to update source',
        deleteFailed: 'Failed to delete source',
        enableFailed: 'Failed to enable source',
        disableFailed: 'Failed to disable source',
      },
      deleteDialog: {
        title: 'Confirm deletion',
        content: 'Are you sure you want to delete this source {{name}}?',
        confirm: 'Delete',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
    },
    serviceGroups: {
      title: 'Specialties',
      addButton: 'Add specialty',
      empty: 'No specialties found',
      modalTitleEdit: 'Edit specialty',
      modalTitleAdd: 'Add specialty',
      fields: {
        name: 'Specialty name',
        services: 'Services',
        servicePlaceholder: 'Pick a service',
      },
      validation: {
        nameRequired: 'Name is required',
        servicesRequired: 'You must select at least 1 service',
      },
      snackbars: {
        saved: 'Specialty saved successfully!',
        updated: 'Specialty updated successfully!',
        deleted: 'Specialty deleted successfully!',
        saveFailed: 'Failed to save specialty',
        updateFailed: 'Failed to update specialty',
        deleteFailed: 'Failed to delete specialty',
        enableFailed: 'Failed to enable specialty',
        disableFailed: 'Failed to disable specialty',
      },
      deleteDialog: {
        title: 'Confirm deletion',
        content: 'Are you sure you want to delete the specialty {{name}}?',
        confirm: 'Delete',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
    },
    branches: {
      title: 'Branches',
      addButton: 'Add branch',
      addButtonDisabledTooltip: 'You have reached the maximum number of branches. Contact us for an upgrade.',
      empty: 'No branches found',
      modalTitleEdit: 'Edit branch',
      modalTitleAdd: 'Add branch',
      linkedCompany: 'Linked company',
      noCompanyWarning: 'This branch has no linked company and cannot issue invoices.',
      addCompany: 'Link company',
      noTenantCompaniesWarning: "You haven't registered a company yet. Register one and link it to this branch so it can issue invoices.",
      registerCompany: 'Register company',
      backToList: 'Branch list',
      detailTitle: 'Basic information',
      fields: {
        name: 'Branch name',
        address: 'Address',
        linkToCompany: 'My linked company',
        aadeBranchCode: 'AADE Branch Code',
        aadeBranchCodeTooltip: 'Number 0 is for the headquarters. You can find installation numbers in your taxis account',
      },
      validation: {
        nameRequired: 'Branch name is required',
        aadeBranchCodeInvalid: 'Branch code must be a non-negative integer',
      },
      snackbars: {
        saved: 'Branch saved successfully!',
        addressRequiredBeforeToggle: 'Please add an address to this branch before enabling or disabling it',
        updated: 'Branch updated successfully!',
        deleted: 'Branch deleted successfully!',
        saveFailed: 'Failed to save branch',
        updateFailed: 'Failed to update branch',
        deleteFailed: 'Failed to delete branch',
        enableFailed: 'Failed to enable branch',
        disableFailed: 'Failed to disable branch',
      },
      deleteDialog: {
        title: 'Confirm deletion',
        content: 'Are you sure you want to delete the branch "{{name}}"?',
        confirm: 'Delete',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
    },
    invoicing: {
      title: 'Invoicing',
      companiesLoadFailed: 'We could not load your companies. Try again.',
      noCompanies: 'You have not registered a company. Register a company to set up document issuing.',
      company: {
        taxId: 'VAT No. {{taxId}}',
      },
      sectionTitle: 'Invoicing series',
      addButton: 'Add series',
      empty: 'You have no invoicing series.\nClick "Add series" to create one.',
      modalTitleAdd: 'Add series',
      modalTitleEdit: 'Edit series',
      fields: {
        documentType: 'Document type',
        seriesCode: 'Series code',
        name: 'Series name',
        nextInvoiceNumber: 'Next invoice number',
      },
      helperTexts: {
        editWarning: 'All records using this series will be affected by the changes.',
        seriesCode: 'Printed with the number (e.g. A-42) and sent to myDATA. It cannot change after creation.',
        creditNotePair: 'A series for "{{type}}" with the same code is created automatically alongside it.',
        noCreatableType: "No new series can be created with the company's saved issuing method.",
        nextInvoiceNumber:
          'Leave empty to start from 1. If you are migrating invoices from another system, enter the next number to issue here.',
      },
      validation: {
        nameRequired: 'Series name is required',
        seriesCodeRequired: 'Series code is required',
        documentTypeRequired: 'Choose a document type',
        seriesCodeTooLong: 'Series code can be at most 50 characters',
        nextInvoiceNumberInvalid: 'Next invoice number must be a whole number of at least 1',
      },
      item: {
        notUsed: 'Not used yet',
        usedInRecords_one: 'Used in {{count}} record',
        usedInRecords_other: 'Used in {{count}} records',
        defaultChip: 'Default',
        active: 'Active',
        activeToggle: 'Series {{code}} active',
        setDefault: 'Make series {{code}} the default',
        edit: 'Edit series {{code}}',
        lastIssuedNumber: 'Last number: {{number}}',
        inactiveChip: 'Inactive',
        historyChip: 'History only',
        historyReadOnly:
          'This series belongs to another issuing method and is kept only for the documents it already issued. It cannot be activated again.',
      },
      tooltips: {
        defaultChip: 'This is the series that appears as default every time an invoice document is created.',
        cannotEdit: 'You cannot change the series name because one or more documents with this series have been sent to myDATA.',
        setDefault: 'Make this the default: it is picked automatically for new documents of this type.',
        cannotDeactivateDefault: 'To deactivate this series, first select another one as default.',
      },
      snackbars: {
        created: 'Series created successfully!',
        updated: 'Series updated successfully!',
        defaultSet: 'Series set as default!',
        deactivated: 'Series deactivated successfully!',
        activated: 'Series activated successfully!',
        createFailed: 'Failed to create series',
        updateFailed: 'Failed to update series',
        defaultFailed: 'Failed to change default series',
        toggleFailed: 'Failed to change series status',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
      aade: {
        fields: {
          userId: 'Username',
          subscriptionKey: 'Password',
        },
        validation: {
          userIdRequired: 'Username is required',
          subscriptionKeyRequired: 'Password is required',
        },
      },
      fiscal: {
        loadFailed: "We could not load this company's issuing settings. Try again.",
        tiles: {
          statuses: {
            OFF: 'Off',
            PENDING: 'Pending',
            ACTIVE: 'Active',
            PROBLEM: 'Problem',
          },
          details: {
            NOT_ISSUED: 'Not issued here',
            VIA_DIRECT: 'Directly to myDATA',
            VIA_PROVIDER: 'Through Wrapp',
            AADE_CREDENTIALS_MISSING: 'The myAADE credentials are missing',
            PROVIDER_NOT_CONNECTED: 'The provider is not connected',
            PROVIDER_PENDING_ACTIVATION: 'Sign-up with the provider is pending',
            PROVIDER_PENDING_MANUAL_LINK: 'Support is linking the account',
            PROVIDER_FAILED: 'Connecting to the provider failed',
          },
        },
        receipts: {
          title: 'Retail receipts',
          description:
            'Do you issue service receipts to individuals from here? If not, the company issues them from a cash register or its own system.',
          methodQuestion: 'How are they issued?',
          methods: {
            DIRECT: {
              label: 'Directly to AADE (myDATA)',
              description: 'No cost per document. Only for businesses without a cash register obligation (hair salons have one).',
            },
            PROVIDER: {
              label: 'Through the provider (Wrapp)',
              description: 'They count towards the document limit of the Wrapp plan.',
            },
          },
        },
        invoices: {
          title: 'Invoices to businesses',
          description: 'Do you issue service invoices to businesses from here? From 1/10/2026 they must be issued through a provider.',
        },
        requirementsTitle: 'What is needed',
        confirmSwitch: {
          DIRECT: {
            title: 'Switch to issuing directly to myDATA?',
            description:
              'New receipts will be issued directly to myDATA. The Wrapp series will not be used for new receipts; the new method needs its own series. Receipts already issued are not affected.',
          },
          PROVIDER: {
            title: 'Switch to issuing through Wrapp?',
            description:
              'New receipts will be issued through Wrapp. The myDATA series will not be used for new receipts; the new method needs its own series. Receipts already issued are not affected.',
          },
          confirm: 'Switch',
          cancel: 'Cancel',
        },
        wrappAccount: {
          title: 'Wrapp account',
          states: {
            NONE: {
              chip: 'Not connected',
              description:
                'A Wrapp account is needed. It is opened once for the tax ID, which cannot change afterwards; sign-up, contract and payment happen on the Wrapp site.',
            },
            PENDING_ACTIVATION: {
              chip: 'Sign-up pending',
              description: 'Sign-up has started but is not complete. Once it is completed at Wrapp, it is activated here automatically.',
            },
            PENDING_MANUAL_LINK: {
              chip: 'Waiting on support',
              description: 'You said the company already has an account. Support will link it; there is nothing for you to do.',
            },
            FAILED: {
              chip: 'Refused',
              description: 'The provider refused to create the account. Support has been notified and will contact you.',
            },
            ACTIVE: {
              chip: 'Connected',
              description: 'Connected to the account {{email}}.',
            },
          },
          shared: 'The same account covers receipts and invoices.',
          choiceSaved: 'Your choice has been saved. Issuing starts automatically once the account is connected.',
          actions: {
            resume: 'Continue sign-up',
          },
        },
        unused: {
          title: 'Saved, not in use',
          providerAccount: {
            chip: 'Not in use',
            description: 'The account stays linked to the tax ID. The subscription is managed at Wrapp.',
          },
        },
        providerOnboarding: {
          button: 'Connect to the provider',
          title: 'Connect to the e-invoicing provider',
          loadFailed: 'Could not load the connection details. Please try again.',
          startFailed: 'Could not start the connection to the provider',
          resumeFailed: 'Could not resume the sign-up. Please try again.',
          checklist: {
            title: 'Some company details are missing',
            description: 'Fill these in on the company details before connecting to the provider.',
          },
          details: {
            description: "These details are what the company's account with the provider is created with.",
            emailHint: 'The email is bound to the provider account permanently and cannot be used for a second account.',
          },
          fields: {
            contactEmail: 'Contact email',
            contactPhone: 'Contact phone',
          },
          confirmTaxId: {
            warningTitle: 'The tax ID cannot be changed after activation',
            warning:
              'The provider binds the tax ID to the account permanently. Each legal entity needs its own account and its own subscription.',
            taxIdLabel: 'Tax ID to be bound',
            description: 'Check that the tax ID and legal name are correct before continuing.',
          },
          existingAccount: {
            question: 'Do you already have a Wrapp account?',
            description:
              'Answer carefully: if the company has its own account and we start a new sign-up anyway, the provider refuses it permanently and only a support request can undo it.',
            answers: {
              false: {
                label: 'No, we do not have an account',
                description: 'A new account will be created and you will be taken to the provider to complete it.',
              },
              true: {
                label: 'Yes, we already have an account',
                description: 'No new account will be created. Support will be notified to link the existing one.',
              },
            },
          },
          manualLink: {
            title: 'Support will link your account',
            description:
              'No new account was created. These are the details that will be sent to the provider to link your existing account.',
            taxId: 'Tax ID',
            contactEmail: 'Contact email',
            partnerUserId: 'Connection id',
          },
          actions: {
            cancel: 'Cancel',
            back: 'Back',
            next: 'Continue',
            confirmTaxId: 'I confirm the tax ID',
            start: 'Start sign-up',
            close: 'Close',
          },
          validation: {
            emailRequired: 'The contact email is required',
            emailInvalid: 'The email is not valid',
            phoneRequired: 'The contact phone is required',
            phoneInvalid: 'The contact phone is not valid',
          },
        },
        credentials: {
          title: 'myAADE credentials',
          titleWithUser: 'myAADE credentials ({{maskedUserId}})',
          description: 'Fill them in so receipts can be issued. They are checked with AADE before they are saved.',
          unusedDescription: 'Not used for new receipts. They are needed to cancel at AADE receipts that were issued directly to myDATA.',
          chips: {
            missing: 'Missing',
            stored: 'Saved',
            unused: 'Not in use',
          },
          subscriptionKeyStored: 'Saved',
          save: 'Save credentials',
          change: 'Change credentials',
          cancelChange: 'Cancel change',
          remove: 'Remove credentials',
          removeHintDirect: 'To remove the credentials, first choose another issuing method.',
          removeDialog: {
            title: 'Remove myAADE credentials',
            content: "Are you sure you want to remove the company's myAADE credentials?",
            confirm: 'Remove',
            cancel: 'Cancel',
          },
        },
        snackbars: {
          saved: "The company's issuing settings were saved",
          saveFailed: 'Saving the issuing settings failed',
          credentialsRemoved: 'The myAADE credentials were removed',
          outcomeUnconfirmed:
            'We did not get a confirmation that this was saved. The settings were reloaded: check whether your change was saved.',
        },
      },
    },
  },
  companies: {
    listTitle: 'Companies',
    addCompany: 'Add company',
    backToList: 'Companies list',
    empty: 'No companies found',
    columns: {
      taxId: 'Tax ID',
      legalName: 'Legal name',
      registeredAddress: 'Address',
      tradeName: 'Activity',
      companyType: 'Company type',
      country: 'Country',
    },
    fields: {
      taxId: 'Tax ID',
      legalName: 'Legal name',
      taxOffice: 'Tax office',
      address: 'Address',
      country: 'Country',
      activity: 'Activity',
      companyType: 'Company type',
      tradeName: 'Trade name',
      location: 'Location',
    },
    sections: {
      basicInfo: 'Basic information',
      linkedContacts: 'Linked contacts',
    },
    contactColumns: {
      lastName: 'Last name',
      firstName: 'First name',
      role: 'Role',
    },
    actions: {
      linkContact: 'Link contact',
      updateViaVies: 'Update via VIES',
      lastUpdated: 'Last updated: {{date}}',
      viaVies: 'via VIES',
    },
    search: {
      mobilePlaceholder: 'Name, Tax ID, Country',
    },
    tabs: {
      details: 'Details',
      contacts: 'Contacts',
    },
    addModal: {
      searchTitle: 'Search in VIES/TaxisNet',
      detailsTitle: 'Company details from VIES/TaxisNet',
      manualTitle: 'Add company',
      manualEntry: 'Manual entry',
      newSearch: 'New search',
    },
    unlinkContact: {
      title: 'Remove contact from company',
      content: 'Do you want to remove the contact {{contactName}} from the company {{companyName}}?',
      confirm: 'Remove',
    },
    snackbars: {
      notFound: 'Company not found',
      updated: 'Company updated',
      saved: 'Company saved successfully!',
      contactLinked: 'Contact linked to the company',
      contactUnlinked: 'Contact removed from the company',
      taxIdAlreadyExists: 'A company with this Tax ID is already registered',
      viesNotActive: 'This Tax ID is not active in VIES',
      viesCredentialsInvalid: 'The login credentials are not correct',
      viesUnavailable: 'VIES service is not available',
    },
    validation: {
      taxIdRequired: 'Tax ID is required',
      countryRequired: 'Country is required',
      legalNameRequired: 'Legal name is required',
      activityRequired: 'Activity is required',
      addressRequired: 'Address is required',
      companyTypeRequired: 'Company type is required',
    },
  },
};

export default en;
